import { create } from "zustand";
import { IGif } from "@/common/api/services/types";
import { mergeGifs } from "@/common/utils/mergeGifs";

interface IPromotedGifsState {
  gifs: IGif[];
  updateGifs: (incomingGifs: IGif[]) => void;
  getGifById: (gifId: string) => IGif | undefined;
}

export const usePromotedGifStore = create<IPromotedGifsState>(
  (set, get) => ({
    gifs: [],
    updateGifs: (incomingGifs: IGif[]) =>
      set((state) => ({
        gifs: mergeGifs(state.gifs, incomingGifs),
      })),
    getGifById: (gifId: string) => {
      const { gifs } = get();

      return gifs.find((gif) => gif.id === gifId || gif.aliasId === gifId);
    },
  }),
);
